import moment from "moment-timezone";
import { DefaultRequest } from "../requests/default.request";

export async function getSeverAndLoacalDiff(): Promise<number> {
    const testPing = await DefaultRequest.testServer();
    const severDate = `${testPing.date}`;
    const diffTimeStamp = testPing.date ? moment(severDate).valueOf() - moment().valueOf() : 0;
    return diffTimeStamp;
}

export function setLocalDateByDiff(diffTimeStamp: number) {
    const curTimeStamp = moment().valueOf() + diffTimeStamp;
    return curTimeStamp;
}